export interface MenuItem {
    route: string;
    icon: string;
    label: string;
    isActive?: boolean;
    separator?: boolean;
    visible?: boolean;
}

export enum Routes {
    CALENDAR = "calendar",
    TASK = "tasks",
    PATIENT = "patient",
    WAITINGROOM = "waitingroom",
    FINANCE = "accounting/income",
    MATERIAL = "material/stock",
    STAFF = "staff",
    LOGIN = "/login",
    ADMIN = "admin"
}